export type Retrieval = {
  id: number;
  remaining_date: string;
  remaining_days: string;
  total_payment: number;
  total_paid: number;
  retrival: number;
  has_partial: boolean;
  is_visible: boolean;
  fullname: string;
  email: string;
  description: string;
  phone_number: string;
  country: string;
  district: string;
  neighbourhood: string;
  street: string;
  flat_number: string;
  lang: string;
  long: string;
  address_description: string;
};

export interface CustomerRetrievalResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: Retrieval[];
}

export const partialTypes = [
  { key: "Hepsi", value: 0 },
  { key: "Peşin", value: 1 },
  { key: "Taksitli", value: 2 },
];
